import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta } from '../../i18n/adminT';
// Popup di ricerca per collegare una persona di riferimento a un utente
// esterno — pensato per anagrafiche grandi (molte persone di riferimento),
// dove un elenco con tutte le caselle di spunta non è più pratico.
export default function ReferenceContactPicker({ excludeIds, onPick, onClose }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    // Attende una breve pausa nella digitazione prima di interrogare il
    // server: con un'anagrafica grande, cercare a ogni singolo carattere
    // sarebbe sia inutilmente pesante sia a rischio di mostrare per un
    // istante risultati di una ricerca già superata, se una risposta più
    // vecchia arriva dopo una più recente.
    const timeoutId = setTimeout(() => {
      api.getReferenceContacts(query)
        .then((res) => { if (mounted) setResults(res.data); })
        .catch(() => {})
        .finally(() => { if (mounted) setLoading(false); });
    }, 300);
    return () => { mounted = false; clearTimeout(timeoutId); };
  }, [query]);

  const available = results.filter((rc) => !excludeIds.includes(rc.id));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h2>{ta('Aggiungi persona di riferimento')}</h2>
        <input
          type="text"
          className="search-input"
          placeholder={ta('Cerca per nome o cognome…')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
          style={{ width: '100%', marginBottom: 14 }}
        />

        <div style={{ maxHeight: 320, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {loading ? (
            <p style={{ color: 'var(--muted-text)', fontSize: '0.88rem' }}>{ta('Ricerca…')}</p>
          ) : available.length === 0 ? (
            <p style={{ color: 'var(--muted-text)', fontSize: '0.88rem' }}>
              {results.length === 0 ? ta('Nessuna persona di riferimento trovata.') : ta('Già tutte collegate.')}
            </p>
          ) : (
            available.map((rc) => (
              <button
                key={rc.id}
                type="button"
                className="btn btn-ghost"
                onClick={() => onPick(rc)}
                style={{ justifyContent: 'flex-start', textAlign: 'left' }}
              >
                {rc.nome} {rc.cognome}
              </button>
            ))
          )}
        </div>

        <div className="btn-row" style={{ marginTop: 16 }}>
          <button type="button" className="btn btn-primary" onClick={onClose}>{ta('Fatto')}</button>
        </div>
      </div>
    </div>
  );
}
